module.exports = __webpack_public_path__ + "img/wx_tracking.c22b2dce.jpg";